// extracted by mini-css-extract-plugin
module.exports = {"error-message":"style_error-message__9acU2","icon":"style_icon__1uGv8","label":"style_label__On0jh","bold-text":"style_bold-text__3WeIG"};